import React, { useEffect, useState } from 'react';

const MIN = '2000-01-01';
const MAX = '2100-12-31';

/**
 * Calendário mensal (mesmas classes do RangeCalendar do board) — seleção de um único dia.
 */
export function SlaFiltrarSingleDateCalendar({ selectedDate, onSelectDate }) {
  const [currentMonth, setCurrentMonth] = useState(() => {
    const base = selectedDate ? new Date(`${selectedDate}T12:00:00`) : new Date();
    return { year: base.getFullYear(), month: base.getMonth() };
  });

  useEffect(() => {
    if (selectedDate) {
      const d = new Date(`${selectedDate}T12:00:00`);
      setCurrentMonth({ year: d.getFullYear(), month: d.getMonth() });
    }
  }, [selectedDate]);

  const daysInMonth = new Date(currentMonth.year, currentMonth.month + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentMonth.year, currentMonth.month, 1).getDay();

  const isDateDisabled = (dateStr) => dateStr < MIN || dateStr > MAX;

  const getDateString = (day) => {
    const y = currentMonth.year;
    const m = String(currentMonth.month + 1).padStart(2, '0');
    const ds = String(day).padStart(2, '0');
    return `${y}-${m}-${ds}`;
  };

  const handleDayClick = (dateStr) => {
    if (isDateDisabled(dateStr)) return;
    onSelectDate(dateStr);
  };

  const prevMonth = () => {
    if (currentMonth.month === 0) {
      setCurrentMonth({ year: currentMonth.year - 1, month: 11 });
    } else {
      setCurrentMonth({ year: currentMonth.year, month: currentMonth.month - 1 });
    }
  };

  const nextMonth = () => {
    if (currentMonth.month === 11) {
      setCurrentMonth({ year: currentMonth.year + 1, month: 0 });
    } else {
      setCurrentMonth({ year: currentMonth.year, month: currentMonth.month + 1 });
    }
  };

  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];
  const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  const days = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push(null);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    days.push(day);
  }

  const todayStr = new Date().toISOString().split('T')[0];

  return (
    <div className="range-calendar">
      <div className="range-calendar-header">
        <button type="button" className="range-calendar-nav" onClick={prevMonth}>
          <i className="bi bi-chevron-left"></i>
        </button>
        <span className="range-calendar-month">
          {monthNames[currentMonth.month]} {currentMonth.year}
        </span>
        <button type="button" className="range-calendar-nav" onClick={nextMonth}>
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
      <div className="range-calendar-weekdays">
        {dayNames.map((day) => (
          <div key={day} className="range-calendar-weekday">{day}</div>
        ))}
      </div>
      <div className="range-calendar-days">
        {days.map((day, index) => {
          if (day === null) {
            return <div key={`empty-${index}`} className="range-calendar-day empty"></div>;
          }
          const dateStr = getDateString(day);
          const disabled = isDateDisabled(dateStr);
          const isSel = dateStr === selectedDate;
          const isToday = dateStr === todayStr;
          return (
            <div
              key={dateStr}
              role="button"
              tabIndex={0}
              className={`range-calendar-day ${disabled ? 'disabled' : ''} ${isSel ? 'start end in-range' : ''} ${isToday ? 'today' : ''}`}
              onClick={() => handleDayClick(dateStr)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleDayClick(dateStr);
                }
              }}
            >
              {day}
            </div>
          );
        })}
      </div>
    </div>
  );
}
